import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "./redux/staffGrossSalesSaga";

import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";

import UpdateBtns from "./smartComponents/UpdateBtns";
import { Dropdown } from "./smartComponents/Dropdown";
import { CustomDateRanges } from "./smartComponents/CustomDateRanges";
import DatePicker from "./smartComponents/DatePicker";

import DataPoints from "./smartComponents/DataPoints";
import DetailsTable from "./smartComponents/DetailsTable";

import "./activePackagesModule.scss";

export const StaffGrossSalesModule = (props) => {
  const dispatch = useDispatch();
  const { isLoading, initialRequest, updatesLoading } = useSelector(
    (state) => state.staffGrossSales
  );

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  return (
    <div id="staffGrossSalesModule">
      <SectionToggle
        autoHeight
        isLoading={isLoading}
        title="Staff Gross Sales"
        content={
          <div id="module-date-filters">
            <div className="edit-selections-bar">
              <div className="top-filter">
                <div className="top__filters-left">
                  <Dropdown keyName="staffs" label="Staff" valueKey="staff_uid" />
                  <Dropdown
                    keyName="exclude_with_no_sales"
                    label="Exclude Staff with No Sales"
                    isMultiSelect={false}
                    width="200px"
                  />
                  <Dropdown
                    keyName="include_deleted"
                    label="Include Deleted Employees"
                    isMultiSelect={false}
                    width="200px"
                  />
                </div>

                <div className="top__filters-right">
                  <CustomDateRanges />
                  <DatePicker />
                </div>
              </div>

              <UpdateBtns />
            </div>

            <div>
              {updatesLoading ? (
                <LoadingAnimation text="Updating data..." />
              ) : (
                <>
                  <DataPoints />
                  <DetailsTable />
                </>
              )}
            </div>
          </div>
        }
      />
    </div>
  );
};
